import { AppointmentChangeOrigin, AppointmentChangeReason, AppointmentData, InvoiceState, PaymentStatus, WaitingListItem } from '../../models';

type AppointmentDeletionGuardData = Pick<AppointmentData, 'packId' | 'payments' | 'invoices'>;

type AppointmentStartData = Pick<AppointmentData, 'date' | 'start'>;

export const hasAppointmentDeletionBlockers = (appointment: AppointmentDeletionGuardData): boolean => {
    return !!appointment.packId
        || !!appointment.payments?.filter(p => p.status === PaymentStatus.Success || p.status === PaymentStatus.Manual).length
        || !!appointment.invoices?.some(invoice => invoice.state === InvoiceState.Issued);
};

export const createDefaultAppointmentChangeReason = (): AppointmentChangeReason => ({
    reasonOrigin: AppointmentChangeOrigin.Client,
    reason: '',
});

export const buildAppointmentStartDateTime = (appointment: AppointmentStartData): Date | null => {
    if (!appointment.date) return null;

    const date = new Date(appointment.date);
    if (Number.isNaN(date.getTime())) return null;

    if (appointment.start) {
        const [hours, minutes] = appointment.start.split(':').map(value => parseInt(value, 10));
        date.setHours(hours || 0, minutes || 0, 0);
    }

    return date;
};

export const isFutureAppointment = (appointment: AppointmentStartData): boolean => {
    const startDate = buildAppointmentStartDateTime(appointment);
    return startDate ? startDate.getTime() > Date.now() : false;
};

export const buildReplacementAppointmentDraft = (
    appointment: Pick<
        AppointmentData,
        'professionalId'
        | 'professionalName'
        | 'professionalColor'
        | 'type'
        | 'room'
        | 'date'
        | 'start'
        | 'end'
        | 'branchId'
    >,
    item: Pick<WaitingListItem, 'clientId' | 'clientName'>,
): Partial<AppointmentData> => ({
    professionalId: appointment.professionalId,
    professionalName: appointment.professionalName,
    professionalColor: appointment.professionalColor,
    type: appointment.type,
    room: appointment.room,
    date: appointment.date,
    start: appointment.start,
    end: appointment.end,
    clientId: item.clientId ?? undefined,
    clientName: item.clientName ?? undefined,
    branchId: appointment.branchId,
});
